<div class="card-container h-100" style="border: 1px solid #e2e8f0; border-radius: 0.5rem; overflow: hidden; background: #ffffff;">
  <div class="card-header py-2 px-3 text-white font-weight-bold" style="background: var(--theme-primary, #123c53); font-size: 0.8125rem; text-transform: uppercase; letter-spacing: 0.5px;">
    <i class="fas fa-address-book mr-1"></i> References
  </div>

  <div class="p-3" *ngIf="!referenceData || referenceData.length === 0">
    <div class="text-center p-3 bg-light rounded text-muted font-size-12">
      <i class="fas fa-info-circle mr-1"></i> No Reference Information Available!
    </div>
  </div>

  <div class="cnt-data p-3" *ngIf="referenceData && referenceData.length > 0">
    <div class="cont" style="display: flex; flex-direction: column; gap: 0.5rem;">
      <div *ngFor="let item of referenceData">
        <div class="p-2.5 rounded border" style="background: #fafbfc; border-color: #e2e8f0 !important;">
          <div class="d-flex justify-content-between align-items-center mb-1">
            <span class="font-weight-bold text-dark" style="font-size: 0.8125rem;">{{ item.CR_PersonName }}</span>
            <span class="badge badge-secondary px-2 py-1">{{ item.CR_ReferenceType }}</span>
          </div>
          <div class="text-muted small" style="font-size: 0.75rem;">
            <i class="fas fa-phone mr-1 text-primary"></i> {{ item.CR_ContactNo }}
          </div>
          <div class="text-muted small mt-1" *ngIf="item.CR_PersonAddress" style="font-size: 0.75rem;">
            <i class="fas fa-map-marker-alt mr-1 text-danger"></i> {{ item.CR_PersonAddress }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>